<template>
  <div
    id="app"
    v-windowResize="{
      handler: 'handleWindowResize',
    }"
    :class="{ 'modal-open': isModalOpen || isNavigationModalOpen }"
  >
    <div :aria-hidden="isModalOpen || isNavigationModalOpen" role="main">
      <router-view />
    </div>
    <cb-modal v-if="isModalOpen"></cb-modal>
    <div
      v-if="isModalOpen || isNavigationModalOpen"
      @click="handleCloseClick"
      class="cb-modal__background"
    ></div>
    <!-- <div
      v-mutationObserver="{ handler: 'handleLivechatUpdate' }"
      id="pypestream-chat-container"
      v-show="isLiveChatOpen"
    ></div> -->
  </div>
</template>

<script>
/* global */
/* global gtag */
import { mapState, mapActions, mapMutations } from 'vuex';
import Modal from './components/Modal.vue';

export default {
  name: 'App',
  data() {
    return {
      allowLiveChatExpanded: false,
    };
  },
  computed: {
    ...mapState({
      isModalOpen: (state) => state.modal.isOpen,
      isNavigationModalOpen: (state) => state.navigationModal.isOpen,
      // isLiveChatOpen: (state) => state.isLiveChatOpen,
      closableOnBackgroundClick: (state) => state.modal.closableOnBackgroundClick,
    }),
  },
  beforeMount() {
    this.tryAutoLogin();
  },
  mounted() {
    this.handleWindowResize();

    // Pypestream('onHide', () => {
    //   this.setIsLiveChatOpen(false);
    // });
  },
  methods: {
    handleWindowResize() {
      if (window.matchMedia('(max-width: 991px)').matches) {
        this.updateScreenSize('mobile');
      } else {
        this.updateScreenSize('desktop');
      }
    },
    // handleLivechatUpdate(mutation) {
    //   if (this.allowLiveChatExpanded) {
    //     this.toggleIsLiveChatExpanded();
    //     if (mutation.addedNodes.length > 0) {
    //       this.setIsLiveChatOpen(true);
    //     } else {
    //       this.setIsLiveChatOpen(false);
    //     }
    //   }
    //   this.allowLiveChatExpanded = true;
    // },
    handleCloseClick() {
      if (this.isModalOpen && this.closableOnBackgroundClick) {
        this.closeModal();
        gtag('event', 'closeModalClick', {
          event_label: 'close',
          event_category: 'modal',
          value: 1,
        });
      }
      if (this.isNavigationModalOpen) {
        this.setIsNavigationModalOpen(false);
        gtag('event', 'closeNavigationModalClick', {
          event_label: 'close',
          event_category: 'navigationModal',
          value: 1,
        });
      }
    },
    ...mapActions(['updateScreenSize', 'tryAutoLogin', 'closeModal']),
    ...mapMutations([
      // 'setIsLiveChatOpen',
      // 'toggleIsLiveChatExpanded',
      'setIsNavigationModalOpen',
    ]),
  },
  components: {
    cbModal: Modal,
  },
};
</script>

<style lang="scss">
@import './styles/_fonts.scss';
@import './styles/_typography.scss';
@import './styles/_buttons.scss';
@import './styles/_checkbox.scss';
@import './styles/_global.scss';

.modal-open {
  height: 100vh;
  overflow-y: hidden;
}

.cb-modal__background {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.45;
}

// #pypestream-chat-container {
//   position: fixed;
//   bottom: 10px;
//   right: 10px;
//   z-index: 9999;

//   @media only screen and (max-height: 720px) {
//     top: 10px;
//     bottom: auto;
//   }
// }
</style>
